import { QUERY_KEYS } from "library/shared";
import { IGrecoClient } from "library/types";
import { UseQueryResult, useQuery } from "react-query";
import api from "service/api";

type Params = {
  countryCode: number | string | null;
  letters?: string;
  enabled?: boolean;
};

export const getClients = async ({ countryCode, letters = "" }: Params) => {
  if (countryCode === null) return;

  const response = await api.get(
    `/clientssearch/${countryCode}/${letters || ` `}`
  );

  return response.data;
};

export function useGetClients({
  countryCode,
  letters,
  enabled = true,
}: Params): UseQueryResult<IGrecoClient[]> {
  return useQuery<IGrecoClient[], Error>(
    [QUERY_KEYS.clients, countryCode, letters],
    () => getClients({ countryCode, letters }),
    {
      enabled: enabled,
      //   onError: (error: any) => {
      //     errorHandler({
      //       label: "Error",
      //       type: notificationTypes.error,
      //       value: "Error while loading offer item data",
      //       errors: error?.message,
      //       fieldName: "",
      //     });
      //   },
    }
  );
}
